import { POINT_TYPES } from '../constants';

export const checkIsGasStation = (value?: string) => POINT_TYPES.gasStation === value;
export const checkIsPlace = (value?: string) => POINT_TYPES.place === value;
export const checkIsCoordinates = (value?: string) => POINT_TYPES.coordinates === value;
export const checkIsCarEBox = (value?: string) =>  POINT_TYPES.carEBox === value;
